export const getBaseUrl = (path: string) => {
    const basePath = path.split('/')[1];
    return `/${basePath}`;
}



// WEBPACK FOOTER //
// ./src/utils.ts